import { jsx as o } from "react/jsx-runtime";
import { InputLabelWrapper as n } from "../input-label-wrapper/InputLabelWrapper.component.js";
import { s as r } from "../../LabeledTextInput.component.module-DkvNCwxG.js";
import { c as l } from "../../index-C3-ZVs5E.js";
import { InputThemeEnum as c } from "../input/types.js";
import { BooleanInput as i } from "../input/BooleanInput.component.js";
const h = ({
  id: e,
  labelText: m,
  inputTheme: a,
  containerClassName: s,
  value: t,
  onInput: p
}) => /* @__PURE__ */ o(
  n,
  {
    labelText: m,
    id: e,
    containerClassName: s,
    className: l(r.label, {
      [r.secondary]: a === c.secondary
    }),
    children: /* @__PURE__ */ o(i, { onInput: p, value: t })
  }
);
export {
  h as LabeledBooleanInput
};
